import AOS from 'aos';
import 'aos/dist/aos.css';

const initAOS = () => {
  AOS.init({
    duration: 600,
    easing: 'ease-out',
    once: true,
    offset: 50,
  });
};

export default initAOS;